{{#if config.label}}
  <label class="switch">
{{/if}}
<input type="checkbox" {{#if context}}checked{{/if}} />
{{#if config.label}}
    <div class="slider"></div>
    <span>{{ config.label }}</span>
  </label>
{{/if}}
{{#if config.comment}}<span class="comment">{{ config.comment }}</span>{{/if}}
